<div
  class="successfull-submit"
  tabindex="0"
  (keyup.enter)="closeDialog()"
  #modalAddDevice
>
  <div class="header mb-2 pb-3">
    <div class="d-flex justify-content-between">
      <h1 class="modal-title m-auto pr-2">{{ 'ADD_A_DEVICE' | translate }}</h1>
    </div>

    <div class="d-flex mt-4 pt-2 pb-2">
      <h2 class="heading1 m-auto">{{ 'GREAT_JOB' | translate }}</h2>
    </div>
    <div
      class="d-flex flex-row justify-content-center align-items-center text-center"
    >
      <span class="m-auto px-4 completed-text">{{
        'COMPLETED_TEXT' | translate
      }}</span>
    </div>
  </div>
  <div class="successfull-container">
    <div class="body pt-3">
      <div class="d-flex justify-content-center pb-60">
        <div>
          <img
            class="check"
            src="/assets/svg/ico-check-circle.svg"
            alt="check circle"
          />
        </div>
        <div class="message">
          <h3 class="title">{{ 'DEVICE_ADDED' | translate }}</h3>
          <p class="dec">
            {{ 'YOUR_DEVICE_IS_NOW_CONNECTED_TO_THE_APP' | translate }}
          </p>
        </div>
      </div>

      <div class="bottom-detail message px-1 pb-120 color-white">
        <h3 class="title">
          {{ 'DEVICE_INSTALLATION_REQUIRED' | translate }}
        </h3>
        <p class="description">
          {{ 'DEVICE_INSTALLATION_REQUIRED_MESSAGE' | translate }}
        </p>
      </div>
    </div>

    <div class="row pb-2">
      <div class="col-12 my-1">
        <button
          class="btn btn-danger px-3 w-100 btn-submit"
          type="button"
          (click)="closeDialog()"
        >
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
